import {configureStore} from '@reduxjs/toolkit'
import projectsSlice from "./project/projectsSlice";
import storiesSlice from "./project/storySlice";
import usersSlice from "./project/userSlice";
import settingSlice from "./project/settingsSlice";
import categoriesSlice from "./project/categoriesSlice";
import componentSlice from "./project/componentsSlice";
import loreSlice from "./project/loreSlice";
import actSlice from "./project/actSlice";
import chaptersSlice from "./project/chapterSlice";
import scenesSlice from "./project/sceneSlice";
import shotsSlice from "./project/shotSlice";
import animationsSlice from "./project/animationsSlice";
import locationSlice from "./project/locationsSlice";
import layerSlice from "./project/layerSlice";
import objectSlice from "./project/objectsSlice";
import characterSlice from "./project/charactersSlice";
import narrationSlice from "./project/narrationSlice";
import choiceSlice from "./project/choiceSlice";
import actionSlice from "./project/actionSlice";
import argumentSlice from "./project/argumentSlice";
import draftSlice from "./project/draftSlice";
import aiSlice from "./project/aiSlice";
import storageSlice from "./project/storageSlice";
import appSettingsSlice from "./project/appSettingsSlice";


export const store = configureStore({
    reducer: {
        projects: projectsSlice,
        stories: storiesSlice,
        users: usersSlice,
        settings: settingSlice,
        categories: categoriesSlice,
        components: componentSlice,
        lores: loreSlice,
        acts: actSlice,
        chapters: chaptersSlice,
        scenes: scenesSlice,
        shots: shotsSlice,
        animations: animationsSlice,
        locations: locationSlice,
        layers: layerSlice,
        objects: objectSlice,
        characters: characterSlice,
        narrations: narrationSlice,
        choiceSlice: choiceSlice,
        actionSlice: actionSlice,
        argumentSlice: argumentSlice,
        draftSlice: draftSlice,
        aiSlice: aiSlice,
        storageSlice: storageSlice,
        appSettingsSlice: appSettingsSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store